<div class="page" *ngIf="!loading && customer">
  <div class="page-header">
    <button mat-icon-button (click)="back()" aria-label="Zurück">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-info">
      <h1><mat-icon class="title-icon">calendar_view_week</mat-icon> Einsatzplanung</h1>
      <span class="sub">{{customer.name}}</span>
    </div>
    <span class="spacer"></span>

    <mat-button-toggle-group [(ngModel)]="view" class="view-toggle" hideSingleSelectionIndicator>
      <mat-button-toggle value="auftraege"><mat-icon>assignment</mat-icon> Aufträge</mat-button-toggle>
      <mat-button-toggle value="personal"><mat-icon>groups</mat-icon> Personal</mat-button-toggle>
    </mat-button-toggle-group>

    <mat-button-toggle-group class="view-toggle" hideSingleSelectionIndicator
                             [value]="daysCount" (change)="setDaysCount($event.value)">
      <mat-button-toggle [value]="7">1 Woche</mat-button-toggle>
      <mat-button-toggle [value]="14">2 Wochen</mat-button-toggle>
    </mat-button-toggle-group>

    <div class="week-nav">
      <button mat-icon-button (click)="prevWeek()" matTooltip="Woche zurück"><mat-icon>chevron_left</mat-icon></button>
      <button mat-stroked-button (click)="today()">Heute</button>
      <button mat-icon-button (click)="nextWeek()" matTooltip="Woche vor"><mat-icon>chevron_right</mat-icon></button>
    </div>

    <button mat-raised-button color="primary" *ngIf="canManage && auftraege.length > 0"
            [matMenuTriggerFor]="createMenu">
      <mat-icon>add</mat-icon> Einsatz planen
    </button>
    <mat-menu #createMenu="matMenu">
      <button mat-menu-item *ngFor="let a of auftraege; trackBy: trackByAuftrag" (click)="createForAuftrag(a)">
        <mat-icon>assignment</mat-icon> {{a.title}}
      </button>
    </mat-menu>
  </div>

  <div class="hint-row">
    <p class="hint" *ngIf="canManage">
      <mat-icon class="inline-icon">touch_app</mat-icon>
      Klick auf leeren Tag = neuer Einsatz · Person/Arbeiter auf Einsatz ziehen = zuteilen ·
      Einsatz ziehen = verschieben · Griff <mat-icon class="inline-icon">drag_handle</mat-icon> ziehen = verlängern
    </p>
    <span class="hint-spacer"></span>
    <div class="legend">
      <span class="legend-item"><span class="legend-dot" data-status="Planned"></span>Geplant</span>
      <span class="legend-item"><span class="legend-dot" data-status="Confirmed"></span>Bestätigt</span>
      <span class="legend-item"><span class="legend-dot" data-status="EnRoute"></span>Unterwegs</span>
      <span class="legend-item"><span class="legend-dot" data-status="Done"></span>Erledigt</span>
    </div>
  </div>

  <div class="board">
    <!-- Linke Seitenleiste: Aufträge (einklappbar) -->
    <aside class="side-panel side-collapsed" *ngIf="leftCollapsed"
           (click)="leftCollapsed = false" matTooltip="Aufträge einblenden">
      <mat-icon>chevron_right</mat-icon>
      <span class="collapsed-label">Aufträge</span>
    </aside>
    <aside class="side-panel" *ngIf="!leftCollapsed">
      <div class="panel-title">
        <mat-icon>assignment</mat-icon> Aufträge
        <span class="panel-spacer"></span>
        <button mat-icon-button class="collapse-btn" (click)="leftCollapsed = true" matTooltip="Ausblenden">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>
      <div class="panel-empty" *ngIf="auftraege.length === 0">Keine offenen Aufträge.</div>
      <div class="drag-card auftrag-drag" *ngFor="let a of auftraege; trackBy: trackByAuftrag"
           [attr.draggable]="canManage" [class.grabbable]="canManage"
           (dragstart)="startDragAuftrag(a, $event)" (dragend)="endDrag()"
           (dblclick)="openAuftrag(a)"
           [matTooltip]="a.title + ' – ' + statusLabels[a.status]">
        <mat-icon class="drag-icon">drag_indicator</mat-icon>
        <div class="drag-info">
          <strong>{{a.title}}</strong>
          <span class="drag-meta">
            <span class="status-chip" [attr.data-status]="a.status">{{statusLabels[a.status]}}</span>
            <span class="count">{{plannedDays(a)}} {{einsatzWort(plannedDays(a))}}</span>
          </span>
        </div>
      </div>
    </aside>

    <!-- Mitte: Zeitraster -->
    <div class="grid-wrap" [class.days-7]="daysCount === 7" [class.days-14]="daysCount === 14">
      <!-- Kopfzeile -->
      <div class="grid-row grid-head">
        <div class="row-label head-label">{{view === 'auftraege' ? 'Auftrag' : 'Person'}}</div>
        <div class="day-cell head-cell" *ngFor="let d of days; trackBy: trackByDay"
             [class.today]="isToday(d)" [class.weekend]="isWeekend(d)">
          <span class="dow">{{d | date:'EE'}}</span>
          <span class="dom">{{d | date:'dd.MM.'}}</span>
        </div>
      </div>

      <!-- Auftrags-Sicht -->
      <ng-container *ngIf="view === 'auftraege'">
        <div class="grid-row" *ngFor="let a of auftraege; trackBy: trackByAuftrag">
          <div class="row-label" (dblclick)="openAuftrag(a)" [matTooltip]="a.title">
            <strong>{{a.title}}</strong>
            <span class="status-chip" [attr.data-status]="a.status">{{statusLabels[a.status]}}</span>
          </div>
          <div class="day-cell" *ngFor="let d of days; trackBy: trackByDay"
               [class.today]="isToday(d)" [class.weekend]="isWeekend(d)"
               [class.creatable]="canManage"
               [class.drop-hover]="hoverKey === 'a' + a.id + '-' + d.getTime()"
               (click)="cellClickCreate(a, d)"
               (dragover)="allowDrop($event, 'a' + a.id + '-' + d.getTime())"
               (dragleave)="clearHover('a' + a.id + '-' + d.getTime())"
               (drop)="dropOnAuftragDay(a, d, $event)">
            <div class="einsatz-chip stacked" [class.chip-clickable]="canManage"
                 *ngFor="let e of assignmentsForAuftragDay(a, d)"
                 [attr.data-status]="e.workStatus"
                 [attr.draggable]="canManage"
                 (dragstart)="startDragAssignment(e, $event)" (dragend)="endDrag()"
                 [class.drop-hover]="hoverKey === 'e' + e.id + '-' + d.getTime()"
                 (dragover)="allowDropOnChip($event, 'e' + e.id + '-' + d.getTime())"
                 (dragleave)="clearHover('e' + e.id + '-' + d.getTime())"
                 (drop)="dropOnAssignment(e, $event)"
                 (click)="$event.stopPropagation(); editAssignment(e)"
                 [matTooltip]="(e.assignedUserName || '') + ' ' + (e.start | date:'HH:mm') + '–' + (e.end | date:'HH:mm') + (e.participantNames.length ? ' + ' + e.participantNames.join(', ') : '') + ((e.workerNames ?? []).length ? ' + ' + e.workerNames.join(', ') : '')">
              <!-- Verantwortlicher (Vorarbeiter) links -->
              <div class="chip-line lead">
                <mat-icon class="chip-icon">person</mat-icon>
                <span class="lead-name">{{shortName(e.assignedUserName)}}</span>
                <span class="resize-handle" *ngIf="canManage" draggable="true"
                      (dragstart)="startResizeAssignment(e, $event)" (dragend)="endDrag()"
                      (click)="$event.stopPropagation()"
                      matTooltip="Griff auf einen Tag ziehen = Einsatz verlängern/verkürzen">
                  <mat-icon>drag_handle</mat-icon>
                </span>
              </div>
              <!-- Zugeteilte Arbeiter/Beteiligte rechts darunter -->
              <div class="chip-line crew" *ngFor="let c of chipCrew(e)">
                <span class="crew-name">{{shortName(c.name)}}</span>
                <mat-icon class="chip-icon">{{c.icon}}</mat-icon>
              </div>
              <div class="chip-line crew more" *ngIf="chipCrewMore(e) > 0">
                +{{chipCrewMore(e)}} weitere
              </div>
            </div>
          </div>
        </div>
        <div class="panel-empty grid-empty" *ngIf="auftraege.length === 0">
          Lege zuerst einen Auftrag an, um Einsätze zu planen.
        </div>
      </ng-container>

      <!-- Personal-Sicht (Team-Mitglieder + Arbeiter dieses Stammkunden) -->
      <ng-container *ngIf="view === 'personal'">
        <div class="grid-row" *ngFor="let u of users; trackBy: trackByUser">
          <div class="row-label">
            <mat-icon class="row-icon">person</mat-icon>
            <strong>{{userLabel(u)}}</strong>
            <span class="count">{{userAssignmentCount(u)}}</span>
          </div>
          <div class="day-cell" *ngFor="let d of days; trackBy: trackByDay"
               [class.today]="isToday(d)" [class.weekend]="isWeekend(d)"
               [class.drop-hover]="hoverKey === 'u' + u.id + '-' + d.getTime()"
               (dragover)="allowDrop($event, 'u' + u.id + '-' + d.getTime())"
               (dragleave)="clearHover('u' + u.id + '-' + d.getTime())"
               (drop)="dropOnUserDay(u, d, $event)">
            <div class="einsatz-chip" [class.chip-clickable]="canManage" *ngFor="let e of assignmentsForUserDay(u, d)"
                 [attr.data-status]="e.workStatus"
                 [attr.draggable]="canManage"
                 (dragstart)="startDragAssignment(e, $event)" (dragend)="endDrag()"
                 (click)="$event.stopPropagation(); editAssignment(e)"
                 [matTooltip]="(e.auftragTitle || e.title) + ' ' + (e.start | date:'HH:mm') + '–' + (e.end | date:'HH:mm')">
              <mat-icon class="chip-icon">assignment</mat-icon>
              {{shortName(e.auftragTitle || e.title)}}
            </div>
          </div>
        </div>

        <div class="grid-row" *ngFor="let w of workers; trackBy: trackByWorker">
          <div class="row-label">
            <mat-icon class="row-icon worker-icon">construction</mat-icon>
            <strong>{{w.name}}</strong>
            <span class="count">{{workerAssignmentCount(w)}}</span>
          </div>
          <div class="day-cell" *ngFor="let d of days; trackBy: trackByDay"
               [class.today]="isToday(d)" [class.weekend]="isWeekend(d)"
               [class.drop-hover]="hoverKey === 'w' + w.id + '-' + d.getTime()"
               (dragover)="allowDrop($event, 'w' + w.id + '-' + d.getTime())"
               (dragleave)="clearHover('w' + w.id + '-' + d.getTime())"
               (drop)="dropOnWorkerDay(w, d, $event)">
            <div class="einsatz-chip" [class.chip-clickable]="canManage" *ngFor="let e of assignmentsForWorkerDay(w, d)"
                 [attr.data-status]="e.workStatus"
                 [attr.draggable]="canManage"
                 (dragstart)="startDragAssignment(e, $event)" (dragend)="endDrag()"
                 (click)="$event.stopPropagation(); editAssignment(e)"
                 [matTooltip]="(e.auftragTitle || e.title) + ' ' + (e.start | date:'HH:mm') + '–' + (e.end | date:'HH:mm')">
              <mat-icon class="chip-icon">assignment</mat-icon>
              {{shortName(e.auftragTitle || e.title)}}
            </div>
          </div>
        </div>

        <div class="panel-empty grid-empty" *ngIf="users.length === 0 && workers.length === 0">
          Noch kein Team zugewiesen – im Stammkunden unter „Team" pflegen.
        </div>
      </ng-container>
    </div>

    <!-- Rechte Seitenleiste: Team-Personal (nur Mitglieder dieses Stammkunden, einklappbar) -->
    <aside class="side-panel side-collapsed" *ngIf="canManage && rightCollapsed"
           (click)="rightCollapsed = false" matTooltip="Team einblenden">
      <mat-icon>chevron_left</mat-icon>
      <span class="collapsed-label">Team</span>
    </aside>
    <aside class="side-panel" *ngIf="canManage && !rightCollapsed">
      <div class="panel-title">
        <mat-icon>groups</mat-icon> Team
        <span class="panel-spacer"></span>
        <button mat-icon-button class="collapse-btn" (click)="rightCollapsed = true" matTooltip="Ausblenden">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
      <div class="panel-empty" *ngIf="users.length === 0">
        Noch kein Team zugewiesen – im Stammkunden unter „Team" pflegen.
      </div>
      <div class="drag-card user-drag" *ngFor="let u of users; trackBy: trackByUser"
           [attr.draggable]="canManage" [class.grabbable]="canManage"
           (dragstart)="startDragUser(u, $event)" (dragend)="endDrag()"
           [matTooltip]="u.email || ''">
        <mat-icon class="drag-icon">drag_indicator</mat-icon>
        <div class="drag-info">
          <strong>{{userLabel(u)}}</strong>
          <span class="drag-meta">
            <span class="role-chip" *ngIf="memberRole(u)" [attr.data-role]="memberRole(u)">{{memberRole(u)}}</span>
            <span class="count">{{userAssignmentCount(u)}} {{einsatzWort(userAssignmentCount(u))}}</span>
          </span>
        </div>
      </div>

      <div class="panel-title panel-title-second"><mat-icon>construction</mat-icon> Arbeiter</div>
      <div class="panel-empty" *ngIf="workers.length === 0">
        Noch keine Arbeiter angelegt – im Stammkunden unter „Team" hinzufügen.
      </div>
      <div class="drag-card worker-drag" *ngFor="let w of workers; trackBy: trackByWorker"
           [attr.draggable]="canManage" [class.grabbable]="canManage"
           (dragstart)="startDragWorker(w, $event)" (dragend)="endDrag()"
           [matTooltip]="w.phone || ''">
        <mat-icon class="drag-icon">drag_indicator</mat-icon>
        <div class="drag-info">
          <strong>{{w.name}}</strong>
          <span class="drag-meta"><span class="count">{{workerAssignmentCount(w)}} {{einsatzWort(workerAssignmentCount(w))}}</span></span>
        </div>
      </div>
    </aside>
  </div>
</div>

<div class="loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
